import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Glyph from 'kepler/lib/components/Glyph';
import Page from '../../lib/page';

class TopicList extends PureComponent {
  static getSearchVersionClass(styleName, hasLabel) {
    return classNames({
      [styleName]: true,
      'topic-item__hasLabel': hasLabel,
    });
  }

  static parserLabels(labels) {
    return typeof labels === 'string' && labels.replace(/,/g, ', ');
  }

  static topicLabel(topicDescription) {
    return topicDescription ? <div className="item-label">{TopicList.parserLabels(topicDescription)}</div> : null;
  }

  // Handle topic tree access by tab button
  handleClickKeyPress(event, content) {
    if (event.which === 13) {
      this.handleClick(content);

      // Update button focus position after selected one topic by keyboard
      setTimeout(() => {
        const topicElement = document.getElementsByClassName('topic-item')[0];
        if (topicElement) {
          topicElement.focus();
        }
      });
    }
  }

  // Handle each Topic item click event
  handleClick(content) {
    this.props.onClick({ content, layer: this.props.layer });
  }

  renderListContent(content) {
    const description = content.topic_description;
    return (
      <div className="topic-list-content" key={content.topic_id}>
        <button
          className={TopicList.getSearchVersionClass(Page.getSearchTopicClassName('topic-item'), description)}
          tabIndex="0"
          onClick={() => this.handleClick(content)}
          onKeyPress={(event) => this.handleClickKeyPress(event, content)}
        >
          <div className="item-container">
            <div className="item-heading">{content.topic_name}</div>
            {TopicList.topicLabel(description)}
          </div>
          <Glyph icon={Page.getArrowDirectionStyle()} className="accordion-icon" aria-hidden="true" />
        </button>
      </div>
    );
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.props.topicList.map((content) => this.renderListContent(content))}
      </div>
    );
  }
}

TopicList.propTypes = {
  topicList: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  layer: PropTypes.number,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

TopicList.defaultProps = {
  topicList: [],
  layer: 1,
  onClick: () => {},
  className: 'topics-list-container',
};

export default TopicList;
